import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormGroup, CircularProgress, Typography } from '@mui/material';
import { getDeleteModalStyles } from '../styles';
import siteManagementService from '../../../services/SiteManagementService';
import { LPLItemDTO, LocationDTO } from '@beable/roster-backend-client-v1';

interface DeleteModalProps {
    open: boolean;
    handleClose: any;
    deletingLocation: boolean;
    item: LocationDTO | LPLItemDTO;
}

export default function DeleteModal(props: DeleteModalProps) {
    const theme = useTheme();
    const styles = getDeleteModalStyles(theme);
    const [isLoading, setIsLoading] = useState(false);
    const [deletionSucceeded, setDeletionSucceeded] = useState(false);
    const [deletionActivated, setDeletionActivated] = useState(false);

    const submitForm = async () => {
        setIsLoading(true);
        if (props.deletingLocation) {
            setDeletionSucceeded(await siteManagementService.deleteLocation(Number(props.item.id)));
        } else {
            setDeletionSucceeded(await siteManagementService.deleteLPLItem(props.item.id!.toString()));
        }
        setIsLoading(false);
        setDeletionActivated(true);
    };

    const resetState = () => {
        setIsLoading(false);
        setDeletionSucceeded(false);
        setDeletionActivated(false);
    };

    const handleClose = () => {
        const success = deletionSucceeded;
        resetState();
        props.handleClose(success);
    }

    return (
        <Modal
            aria-labelledby="delete-modal-title"
            aria-describedby="delete-modal-description"
            open={props.open}
            onClose={(_event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={[styles.paper, styles.deleteModal]}>
                <h2 id="delete-modal-title">Are you sure you would like to delete the {props.item.name} {props.deletingLocation ? 'location' : 'site'} record?</h2>
                <p id="delete-modal-description">This action cannot be undone.</p>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    {isLoading ? <CircularProgress color="primary" /> : undefined}
                    {deletionSucceeded && deletionActivated ? <Typography sx={styles.greenTxt}>Deletion succeeded!</Typography> : undefined}
                    {!deletionSucceeded && deletionActivated ? <Typography sx={styles.redTxt}>Deletion failed!</Typography> : undefined}
                </FormGroup>
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button variant="contained" disabled={deletionActivated && deletionSucceeded} sx={styles.btnDanger} onClick={submitForm}>Delete</Button>
                    <Button variant="contained" onClick={handleClose} sx={styles.ml2}>Close</Button>
                </FormGroup>
            </Box>
        </Modal>
    );
}